import styled from "styled-components";
import Snackbar from "components/Snackbar/Snackbar.js";

export const SnackbarStyled = styled(Snackbar)`
  z-index: 100000 !important;
`;
